import React, { useEffect, useRef } from 'react';
import './CustomScrollbar.css';

const CustomScrollbar = () => {
  const indicatorRef = useRef(null);

  useEffect(() => {
    const updateScrollbar = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const maxScroll = documentHeight - windowHeight;
      const scrollPercentage = (scrollPosition / maxScroll);
      
      // Calculate height based on scroll position
      const minHeight = 50; // Starting height
      const maxHeight = windowHeight * 0.8; // Maximum height
      const height = minHeight + (maxHeight - minHeight) * scrollPercentage;
      
      if (indicatorRef.current) {
        indicatorRef.current.style.height = `${height}px`;
      }
    };

    window.addEventListener('scroll', updateScrollbar);
    window.addEventListener('resize', updateScrollbar);
    
    // Initial update
    updateScrollbar();

    return () => {
      window.removeEventListener('scroll', updateScrollbar);
      window.removeEventListener('resize', updateScrollbar);
    };
  }, []);

  return (
    <div className="custom-scrollbar-container">
      <div ref={indicatorRef} className="custom-scrollbar-indicator" />
    </div>
  );
};

export default CustomScrollbar; 